import React from 'react';
import SummarySectionCard from './SummarySectionCard';

interface NextStepsSummaryCardProps {
  coachingForThisClient?: string[];
  coachingForGeneralImprovement?: string[];
  onViewDetails: () => void;
}

const NextStepsSummaryCard: React.FC<NextStepsSummaryCardProps> = ({
  coachingForThisClient,
  coachingForGeneralImprovement,
  onViewDetails,
}) => {
  const hasClient = (coachingForThisClient?.length ?? 0) > 0;
  const hasGeneral = (coachingForGeneralImprovement?.length ?? 0) > 0;

  if (!hasClient && !hasGeneral) {
    return (
      <SummarySectionCard
        title="Next Steps"
        resultContent={null}
        missingDataMessage="Coaching recommendations are not yet available. Re-analyze this session."
        onViewDetails={onViewDetails}
        className="col-span-full"
      />
    );
  }

  const resultContent = (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {hasClient && (
        <div className="bg-info-tint border border-info rounded-lg p-3">
          <p className="text-[10px] font-bold text-info uppercase tracking-wider mb-2">For This Client</p>
          <ol className="space-y-1.5 list-decimal list-inside">
            {coachingForThisClient!.map((step, idx) => (
              <li key={idx} className="text-xs text-ink leading-relaxed">{step}</li>
            ))}
          </ol>
        </div>
      )}
      {hasGeneral && (
        <div className="bg-info-tint border border-info rounded-lg p-3">
          <p className="text-[10px] font-bold text-info uppercase tracking-wider mb-2">General Improvements</p>
          <ol className="space-y-1.5 list-decimal list-inside">
            {coachingForGeneralImprovement!.map((tip, idx) => (
              <li key={idx} className="text-xs text-ink leading-relaxed">{tip}</li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );

  return (
    <SummarySectionCard
      title="Next Steps"
      resultContent={resultContent}
      onViewDetails={onViewDetails}
      className="col-span-full"
    />
  );
};

export default NextStepsSummaryCard;
